import React from 'react';


const Footerdash = () => {

  return (
    <footer className="footer mt-auto">
      <div className="copyright bg-white">
        <p>
        © <span id="copy-year">2025</span> Copyright cmspvt.
                {/* <Link className="text-primary" to="/" target="_blank"> cms</Link>. */}
         </p>
      </div>
    </footer>
  );
};

export default Footerdash;
